module.exports = __webpack_public_path__ + "static/1-59f15394b1855cdcf3f2d81320828b3c.jpg";